import { SignupPageTemplate } from '@/templates/try/cloud/signup/signup-page/src/signup-page.template';

export const SignupPage = () => <SignupPageTemplate />;
